import { useSelector } from 'react-redux';
import { useNavegate } from 'App/hooks';
import { getCanEnterAdmin } from 'domains/Auth/authSlice/authSelectors';
import { BILLING_ROUTES } from 'domains/Billing/billingRoutes';
import { useGetLastPayment } from 'domains/Billing/Checkout/hooks';
import { useStoreInfo } from 'domains/PartnersApps/hooks';
import { useIsLogged } from '../index';
import useStoreStatus from '../useStoreStatus';

function useCanEnterAdmin() {
  const canEnterAdmin = useSelector(getCanEnterAdmin);
  const { pathname } = useNavegate();
  const { storeStatus } = useStoreStatus();
  const { hasFirstPayment } = useStoreInfo();
  const { isLogin } = useIsLogged();
  const { isSuccess, paymentStatus } = useGetLastPayment(
    'plan-cost',
    undefined,
    isLogin,
  );
  const allowedBecauseOfInProcessPayment =
    isSuccess && paymentStatus === 'IN_PROCESS';

  const allowedPaths = [BILLING_ROUTES.coupons];
  const isHandoffStore = !hasFirstPayment && storeStatus === 'store_down';

  return (
    canEnterAdmin ||
    allowedBecauseOfInProcessPayment ||
    (allowedPaths.includes(pathname) && isHandoffStore)
  );
}

export default useCanEnterAdmin;
